import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgEnvelop({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={20} cy={20} r={20} fill="#E9F4F3" />
            <path
                d="M19.12 21.9c.438.438 1.148.438 1.587 0l8.702-8.702a.45.45 0 0 0-.252-.762 1.765 1.765 0 0 0-.258-.02H10.93c-.087 0-.173.007-.26.02a.45.45 0 0 0-.252.762l8.7 8.702Z"
                fill="currentColor"
            />
            <path
                d="M30.594 14.062a.163.163 0 0 0-.18.035l-5.57 5.57a.225.225 0 0 0 0 .318l4.53 4.53a.674.674 0 1 1-.951.954l-4.53-4.53a.225.225 0 0 0-.319 0l-1.913 1.912a2.47 2.47 0 0 1-3.492 0l-1.915-1.91a.226.226 0 0 0-.318 0l-4.53 4.53a.674.674 0 0 1-.953-.954l4.531-4.53a.226.226 0 0 0 0-.318l-5.57-5.57a.162.162 0 0 0-.18-.035.164.164 0 0 0-.1.15v10.78c0 .992.804 1.796 1.796 1.796h17.968c.992 0 1.797-.804 1.797-1.796v-10.78a.163.163 0 0 0-.101-.152Z"
                fill="currentColor"
            />
        </svg>
    )
}
SvgEnvelop.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgEnvelop
